import { Breadcrumb, Col, ConfigProvider, Modal, notification, Row, Table } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import productAPI from '~/api/ProductAPI';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import EmptyForm from '~/components/Empty';
import CancelModal from '~/components/FormCancel';
import config from '~/config';
import { updateComboServiceCartStore } from '~/store/actions/CartComboServiceAction';
import { updateProductCartStore } from '~/store/actions/CartProductAction';
import { getNumberWithCommas } from '~/utils';
import styles from './Cart.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';

const cx = classNames.bind(styles);

const TableData = styled.div`
    width: 100%;
    .ant-table-container {
        overflow-x: auto;
    }
    .ant-table-thead > tr > th {
        font-weight: 700;
        font-size: 16px;
    }
    .ant-table-tbody > tr > td,
    .ant-table-thead > tr > th,
    .ant-table tfoot > tr > td,
    .ant-table tfoot > tr > th {
        padding: 16px 5px;
    }
`;

const Cart = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const cartProductInfo = useSelector((state) => state.cartProduct.cartProductInfo);
    const cartComboServiceInfo = useSelector((state) => state.cartComboService.cartComboServiceInfo);

    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';
    // const isLogin = !!localStorage.getItem('token');

    const [totalPrice, setTotalPrice] = useState(0);
    const [listOrder, setListOrder] = useState([]);

    const [dataProductOrder, setDataProductOrder] = useState([]);
    const [dataComboServiceOrder, setDataComboServiceOrder] = useState([]);

    const [itemRemove, setItemRemove] = useState({});
    const [isShowRemoveItem, setIsShowRemoveItem] = useState(false);

    const [textModal, setTextModal] = useState('');
    const [typeOrder, setTypeOrder] = useState('');

    const [selectedRowsArrayProduct, setSelectedRowsArrayProduct] = useState([]);
    const [selectedRowsArrayService, setSelectedRowsArrayService] = useState([]);

    const [isShowRequireLogin, setIsShowRequireLogin] = useState(false);
    const onAgreeLogin = () => {
        navigate(config.routes.login);
        setIsShowRequireLogin(false);
    };
    const onRejectLogin = () => {
        setIsShowRequireLogin(false);
    };

    const handleShowRemoveItem = (data, type) => {
        setItemRemove(data);
        setIsShowRemoveItem(true);
        setTypeOrder(type);
        if (type === 'PRODUCT') {
            setTextModal('Do you want to delete this product?');
        } else {
            setTextModal('Do you want to delete this service pack?');
        }
    };
    const onRejectRemoveItem = () => {
        setItemRemove({});
        setIsShowRemoveItem(false);
    };
    const onAgreeRemoveItem = () => {
        if (typeOrder === 'PRODUCT') {
            let temp = dataProductOrder.filter((item) => {
                return (
                    (item.id === itemRemove.id && item.sharer_id !== itemRemove.sharer_id) || item.id !== itemRemove.id
                );
            });

            setDataProductOrder([...temp]);
            dispatch(updateProductCartStore(temp));

            let orders = listOrder.filter((item) => {
                return (
                    (item.id === itemRemove.id && item.sharer_id !== itemRemove.sharer_id) || item.id !== itemRemove.id
                );
            });
            setListOrder([...orders]);
            handleUpdateListOrder(temp, orders);
        } else {
            let temp = dataComboServiceOrder.filter((item) => item.id !== itemRemove.id);
            setDataComboServiceOrder([...temp]);
            dispatch(updateComboServiceCartStore(temp));

            let orders = listOrder.filter((item) => item.id !== itemRemove.id);
            setListOrder([...orders]);
            handleUpdateListOrder(temp, orders);
        }

        setIsShowRemoveItem(false);
    };
    const handleChangeAmountItem = async (item, index, type, typeOrder) => {
        let temp_dataOrder = [];
        if (typeOrder === 'PRODUCT') {
            if (type === 'SUB') {
                if (item.amount > 0) {
                    if (item.amount === 1) {
                        handleShowRemoveItem(item, typeOrder);
                    } else {
                        item.amount--;
                    }
                }
            } else {
                const maximum = await handleGetOneProductInfo(item.id);
                if (maximum === 0) {
                    notification.open({
                        message: 'Product sold out!',
                        duration: 2,
                        placement: 'top',
                    });
                } else {
                    if (item.amount < maximum) {
                        item.amount++;
                    } else {
                        notification.open({
                            message: 'Inventory quantity exceeded!',
                            duration: 2,
                            placement: 'top',
                        });
                    }
                }
            }
            // item.total_price = (item.price - item.sale_price) * item.amount;
            item.deducted_price = item.price - item.sale_price;
            item.total_price = item.deducted_price * item.amount;
            let temp_dataOrder = dataProductOrder;
            temp_dataOrder[index] = item;
            setDataProductOrder([...temp_dataOrder]);
            dispatch(updateProductCartStore(temp_dataOrder));
        } else {
            if (type === 'SUB') {
                if (item.amount_order > 0) {
                    if (item.amount_order === 1) {
                        handleShowRemoveItem(item, typeOrder);
                    } else {
                        item.amount_order--;
                    }
                }
            } else {
                item.amount_order++;
            }
            let currentPrice = item?.discount ? item.price - item.discount : item.price;
            item.total_price = currentPrice * item.amount_order;
            let temp_dataOrder = dataComboServiceOrder;
            temp_dataOrder[index] = item;
            setDataComboServiceOrder([...temp_dataOrder]);
            dispatch(updateComboServiceCartStore(temp_dataOrder));
        }
        handleUpdateListOrder(temp_dataOrder, listOrder);
    };

    // Product
    const handleGetOneProductInfo = async (product_id) => {
        try {
            let product = {};
            const params = {
                fields: '["$all"]',
            };
            const res = await productAPI.getOneProductAPI(product_id, params);
            if (res.code === 200) {
                product = { ...res.results.object };
                return product.inventory_amount_branch;
            }
        } catch (err) {
            console.log(err);
        }
    };
    const productColumns = [
        {
            title: 'Product',
            dataIndex: 'id',
            key: 'id',
            render: (text, record, index) => (
                <Row className={cx('product_info')} onClick={() => navigate(`/thong-tin-san-pham/${record?.id}`)}>
                    <Col xs={6} xl={5}>
                        <Row className={cx('image')}>
                            <img src={record?.thumbnail || IMAGES.ImagePlaceholder} alt="" />
                        </Row>
                    </Col>
                    <Col xs={18} xl={19} className={cx('content')}>
                        <div>
                            <Row className={cx('name')}>{record?.title}</Row>
                            <Row className={cx('type')}>
                                <span>{record?.category?.title}</span>
                            </Row>
                        </div>
                    </Col>
                </Row>
            ),
            width: '40%',
        },
        // {
        // title: 'Price',
        //     dataIndex: 'deducted_price',
        //     key: 'deducted_price',
        //     align: 'center',
        // render: (value) => <span className={cx('price_item')}>{getNumberWithCommas(value)} d </span>,
        //     width: '15%',
        // },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            align: 'center',
            render: (text, record, index) => (
                <span className={cx('price_item')}>
                    {getNumberWithCommas(record?.sale_price ? record?.price - record?.sale_price : record?.price)} d
                </span>
            ),
            width: '15%',
        },
        {
            title: 'Quantity',
            dataIndex: 'amount',
            key: 'amount',
            align: 'center',
            width: '20%',
            render: (text, record, index) => {
                return (
                    <Row span={8} className={cx('border')}>
                        <div
                            className={cx('button_count')}
                            onClick={() => handleChangeAmountItem(record, index, 'SUB', 'PRODUCT')}
                        >
                            <img src={SVGS.IconSub} alt="" />
                        </div>
                        <span className={cx('count')}>{record?.amount}</span>
                        <div
                            className={cx('button_count')}
                            onClick={() => handleChangeAmountItem(record, index, 'PLUS', 'PRODUCT')}
                        >
                            <img src={SVGS.IconPlus} alt="" />
                        </div>
                    </Row>
                );
            },
        },
        {
            title: 'Into Money',
            dataIndex: 'total_price',
            key: 'total_price',
            align: 'center',
            render: (value) => <span className={cx('total_price_item')}>{getNumberWithCommas(value)} d </span>,
            width: '20%',
        },
        {
            title: '',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            render: (text, record, index) => (
                <img
                    src={SVGS.IconClose}
                    className={cx('action_close')}
                    onClick={() => handleShowRemoveItem(record, 'PRODUCT')}
                    alt=""
                />
            ),
            width: '5%',
        },
    ];
    const productColumnsMobile = [
        {
            title: 'Select all',
            dataIndex: 'id',
            key: 'id',
            render: (text, record, index) => (
                <Row className={cx('item_product')}>
                    <Col
                        xs={6}
                        className={cx('image_product')}
                        onClick={() => navigate(`/thong-tin-san-pham/${record?.id}`)}
                    >
                        <img src={record?.thumbnail || IMAGES.ImagePlaceholder} alt="" />
                    </Col>
                    <Col xs={16} className={cx('info_product')}>
                        <p onClick={() => navigate(`/thong-tin-san-pham/${record?.id}`)}>{record?.title}</p>
                        <p className={cx('price_item')} onClick={() => navigate(`/thong-tin-san-pham/${record?.id}`)}>
                            {getNumberWithCommas(
                                record?.sale_price ? record?.price - record?.sale_price : record?.price,
                            )}{' '}
                            d{' '}
                        </p>
                        <Row span={8} style={{ alignItems: 'center' }}>
                            <div
                                className={cx('button_count')}
                                onClick={() => handleChangeAmountItem(record, index, 'SUB', 'PRODUCT')}
                            >
                                <img src={SVGS.IconSub} alt="" />
                            </div>
                            <span className={cx('count')}>{record?.amount}</span>
                            <div
                                className={cx('button_count')}
                                onClick={() => handleChangeAmountItem(record, index, 'PLUS', 'PRODUCT')}
                            >
                                <img src={SVGS.IconPlus} alt="" />
                            </div>
                        </Row>
                    </Col>
                    <Col>
                        <img
                            src={SVGS.IconClose}
                            className={cx('action_close')}
                            onClick={() => handleShowRemoveItem(record, 'PRODUCT')}
                            alt=""
                        />
                    </Col>
                </Row>
            ),
        },
    ];
    const productRowSelection = {
        selectedRowKeys: selectedRowsArrayProduct,
        onChange: (selectedRowKeys, selectedRows) => {
            setTypeOrder('PRODUCT');
            setListOrder(selectedRows);
            setSelectedRowsArrayProduct(selectedRowKeys);
            setSelectedRowsArrayService([]);
        },
        getCheckboxProps: (record) => ({
            disabled: record.inventory_amount_branch === 0 || record.amount > record.inventory_amount_branch,
        }),
    };

    // Combo service
    const comboServiceColumns = [
        {
            title: 'Service package',
            dataIndex: 'id',
            key: 'id',
            render: (text, record, index) => (
                <Row className={cx('product_info')} onClick={() => navigate(`/goi-dich-vu-chi-tiet/${record?.id}`)}>
                    <Col xs={6} xl={5}>
                        <Row className={cx('image')}>
                            <img src={record?.image || IMAGES.ImagePlaceholder} alt="" />
                        </Row>
                    </Col>
                    <Col xs={18} xl={19} className={cx('content')}>
                        <div>
                            <Row className={cx('name')}>{record?.title}</Row>
                            <Row className={cx('type')}>
                                <span>{record?.category?.title}</span>
                            </Row>
                        </div>
                    </Col>
                </Row>
            ),
            width: '40%',
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            align: 'center',
            render: (text, record, index) => (
                <span className={cx('price_item')}>
                    {getNumberWithCommas(record?.sale_price ? record?.price - record?.sale_price : record?.price)} d
                </span>
            ),
            width: '15%',
        },
        {
            title: 'Quantity',
            dataIndex: 'amount_order',
            key: 'amount_order',
            align: 'center',
            width: '20%',
            render: (text, record, index) => {
                return (
                    <Row span={8} className={cx('border')}>
                        <div
                            className={cx('button_count')}
                            onClick={() => handleChangeAmountItem(record, index, 'SUB', 'COMBOSERVICE')}
                        >
                            <img src={SVGS.IconSub} alt="" />
                        </div>
                        <span className={cx('count')}>{record?.amount_order}</span>
                        <div
                            className={cx('button_count')}
                            onClick={() => handleChangeAmountItem(record, index, 'PLUS', 'COMBOSERVICE')}
                        >
                            <img src={SVGS.IconPlus} alt="" />
                        </div>
                    </Row>
                );
            },
        },
        {
            title: 'Into Money',
            dataIndex: 'total_price',
            key: 'total_price',
            align: 'center',
            render: (value) => <span className={cx('total_price_item')}>{getNumberWithCommas(value)} d </span>,
            width: '20%',
        },
        {
            title: '',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            render: (text, record, index) => (
                <img
                    src={SVGS.IconClose}
                    className={cx('action_close')}
                    onClick={() => handleShowRemoveItem(record, 'COMBOSERVICE')}
                    alt=""
                />
            ),
            width: '5%',
        },
    ];
    const comboServiceRowSelection = {
        selectedRowKeys: selectedRowsArrayService,
        onChange: (selectedRowKeys, selectedRows) => {
            setTypeOrder('COMBOSERVICE');
            setListOrder(selectedRows);
            setSelectedRowsArrayService(selectedRowKeys);
            setSelectedRowsArrayProduct([]);
        },
        // getCheckboxProps: (record) => ({
        //     disabled: record.inventory_amount_branch === 0 || record.amount_order > record.inventory_amount_branch,
        // }),
    };

    // Order
    const getTotalPriceOrder = (orders) => {
        let total = 0;
        for (const item of orders) {
            total += item.total_price;
        }
        setTotalPrice(total);
    };
    const handleUpdateListOrder = (temp_dataProductOrder, old_listOrder) => {
        let temp_listOrder = old_listOrder;
        for (let i = 0; i < temp_listOrder.length; i++) {
            for (let j = 0; j < temp_dataProductOrder.length; j++) {
                if (temp_listOrder[i].id === temp_dataProductOrder[j].id) {
                    temp_listOrder[i] = temp_dataProductOrder[j];
                }
            }
        }
        getTotalPriceOrder(temp_listOrder);
        setListOrder(temp_listOrder);
    };
    const handleCheckOut = () => {
        if (typeOrder === 'PRODUCT') {
            localStorage.setItem('listProductOrder', JSON.stringify([...listOrder]));
            localStorage.setItem('totalPriceProductOrder', totalPrice);
        } else {
            localStorage.setItem('comboServiceOrder', JSON.stringify([...listOrder]));
            localStorage.setItem('totalPriceComboServiceOrder', totalPrice);
        }
        if (isLogin) {
            if (typeOrder === 'PRODUCT') {
                navigate(config.routes.checkOut);
            } else {
                navigate(config.routes.checkOutComboService);
            }
        } else {
            localStorage.setItem('navigateAfterLogin', config.routes.checkOut);
            setIsShowRequireLogin(true);
        }
    };

    useEffect(() => {
        getTotalPriceOrder(listOrder);
    }, [listOrder]);

    const handleGetDataProductOrder = async (cartProductInfo) => {
        const params = {
            fields: '["$all"]',
        };
        let listNoShareId = [];
        let listHaveShareId = [];
        for (const item of cartProductInfo) {
            const res = await productAPI.getOneProductAPI(item.id, params);
            item.inventory_amount_branch = res.results.object.inventory_amount_branch;
            item.thumbnail = res.results.object.thumbnail;
            item.title = res.results.object.title;
            item.price = res.results.object.price;
            if (item.sharer_id && item.sharer_id !== userInfo?.id) {
                item.sale_price = (item.price * 5) / 100;
            } else {
                item.sale_price = 0;
            }
            item.deducted_price = item.price - item.sale_price;
            item.total_price = item.amount * item.deducted_price;
            if (item.sharer_id && item.sharer_id === userInfo?.id) {
                listHaveShareId.push(item);
            } else {
                listNoShareId.push(item);
            }
        }
        if (listHaveShareId.length) {
            for (const itemHaveShare of listHaveShareId) {
                for (const itemNoShare of listNoShareId) {
                    if (itemNoShare.id === itemHaveShare.id) {
                        itemNoShare.amount = itemNoShare.amount + itemHaveShare.amount;
                        itemNoShare.total_price = itemNoShare.amount * itemNoShare.deducted_price;
                    }
                }
            }
        }
        setDataProductOrder(listNoShareId);
        dispatch(updateProductCartStore(listNoShareId));
    };

    useEffect(() => {
        handleGetDataProductOrder(cartProductInfo);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setDataComboServiceOrder(cartComboServiceInfo);
        // eslint-disable-next-line
    }, [cartComboServiceInfo]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangGioHang');
        // eslint-disable-next-line
    }, []);
    return (
        <>
            {/* pc */}
            <div className={cx('wrapper')}>
                <div>
                    <Breadcrumb className={cx('breadcrumb')}>
                        <Breadcrumb.Item>Product information</Breadcrumb.Item>
                        <Breadcrumb.Item className={cx('breadcrumItemActive')}>Shopping Cart</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className={cx('headingBlock')}>
                    <h3>Shopping Cart</h3>
                </div>

                <div className={cx('content_product')}>
                    <TableData>
                        <ConfigProvider renderEmpty={() => <EmptyForm />}>
                            <Table
                                dataSource={[...dataProductOrder]}
                                columns={productColumns}
                                headerClassName={cx('header_table')}
                                pagination={false}
                                rowSelection={{
                                    ...productRowSelection,
                                }}
                            />
                        </ConfigProvider>
                    </TableData>
                    {/* <TableData className={cx('combo_service_section')}>
                <ConfigProvider renderEmpty={() => <EmptyForm />}>
                    <Table
                        dataSource={[...dataComboServiceOrder]}
                        columns={comboServiceColumns}
                        headerClassName={cx('header_table')}
                        pagination={false}
                        rowSelection={{
                            ...comboServiceRowSelection,
                        }}
                    />
                </ConfigProvider>
            </TableData> */}

                    <Row justify="end" className={cx('total_price_order')}>
                        {getNumberWithCommas(totalPrice)} d
                    </Row>
                    <Row justify="end">
                        {totalPrice ? (
                            <div className={cx('btn_check_out')} onClick={handleCheckOut}>
                                Order
                            </div>
                        ) : (
                            <div className={cx('btn_check_out_disable')}>Order</div>
                        )}
                    </Row>
                </div>
                {isShowRemoveItem && (
                    <Modal
                        centered
                        visible={isShowRemoveItem}
                        onCancel={() => setIsShowRemoveItem(false)}
                        maskClosable={false}
                        footer={null}
                        className="otp-modal"
                        width={500}
                    >
                        <div style={{ padding: '20px 20px' }}>
                            <CancelModal
                                onAgreeCancel={onAgreeRemoveItem}
                                onRejectCancel={onRejectRemoveItem}
                                text={textModal}
                            />
                        </div>
                    </Modal>
                )}
            </div>

            {/* mobile */}
            <div className={cx('mb')}>
                <div className={cx('title_header')}>
                    <Row className={cx('header_row')}>
                        <Col xs={8}>
                            <img
                                src={SVGS.ImageChevronLeft}
                                alt="icon chevron left"
                                className={cx('btn_search')}
                                onClick={() => navigate(-1)}
                            />
                        </Col>
                        <Col xs={16}>
                            <span className={cx('header_title')}>Shopping Cart</span>
                        </Col>
                    </Row>
                </div>
                <Row className={cx('container_card')}>
                    <TableData>
                        <ConfigProvider renderEmpty={() => <EmptyForm />}>
                            <Table
                                dataSource={[...dataProductOrder]}
                                columns={productColumnsMobile}
                                headerClassName={cx('header_table')}
                                pagination={false}
                                rowSelection={{
                                    ...productRowSelection,
                                }}
                            />
                        </ConfigProvider>
                    </TableData>
                    <Row className={cx('check_out')}>
                        <Col>
                            <p className={cx('total')}>Total:</p>
                            <p className={cx('total_price')}> {getNumberWithCommas(totalPrice)} d</p>
                        </Col>
                        <Col>
                            {totalPrice ? (
                                <div className={cx('btn_check_out')} onClick={handleCheckOut}>
                                    Order
                                </div>
                            ) : (
                                <div className={cx('btn_check_out_disable')}>Order</div>
                            )}
                        </Col>
                    </Row>
                </Row>
                {isShowRequireLogin && (
                    <Modal
                        centered
                        visible={isShowRequireLogin}
                        onCancel={() => setIsShowRequireLogin(false)}
                        maskClosable={false}
                        footer={null}
                        className="otp-modal"
                        width={500}
                    >
                        <div style={{ padding: '20px 20px' }}>
                            <CancelModal
                                onAgreeCancel={onAgreeLogin}
                                onRejectCancel={onRejectLogin}
                                text="Do you want to log in to continue?"
                            />
                        </div>
                    </Modal>
                )}
            </div>
        </>
    );
};

export default Cart;
